<template>
    <div class="app-secondary-container">
        <main class="app-main">
            <router-view/>
        </main>
    </div>
</template>
<script>
import {mapActions} from 'vuex';

export default {}
</script>
